app.apply(app.options, {
  /**
   * Default options for the datepicker plugin.
   */

  datepicker: function datepicker() {
    return {
      editable: true,
      format: 'dd/mm/yyyy',
      selectMonths: false,
      selectYears: false,
      closeOnSelect: true,
      closeOnClear: true,
      klass: {
        buttonClear: 'datepicker--clear',
        buttonClose: 'datepicker--close',
        buttonToday: 'datepicker--today',
        active: 'datepicker--active'
      },
      onRender: function onRender() {
        // Re-initialises the accessibility improvements when the user renders the datapicker popup.
        app.helpers.improveDatePickerAccessibility($('.datepicker--active'));
      }
    };
  },
  /**
   * Default options for the tooltips plugin.
   */

  tooltips: function tooltips() {
    return {
      theme: 'tooltip',
      interactive: true,
      trigger: 'click'
    };
  },
  /**
   * Default options for the select2 plugin.
   */

  select: function select() {
    return {
      minimumResultsForSearch: 10
    };
  },
  /**
   * Default options for the range slider plugin.
   */

  slider: function slider() {
    return {
      range: {
        'min': 0,
        'max': 100
      },
      start: [50],
      connect: 'lower',
      pips: {
        mode: 'steps',
        density: 3,
        format: wNumb({
          decimals: 0
        })
      },
      tooltips: [wNumb({
        decimals: 0
      })],
      format: wNumb({
        decimals: 0
      })
    };
  },
  /**
   * Default options for the modal plugin.
   */

  modal: function modal() {
    return {
      showCloseBtn: false,
      closeOnBgClick: false
    };
  },
  /**
   * Default options for the imprint plugin.
   * See https://github.com/mattbrailsford/imprintjs for additional options.
   */

  deviceImprint: function deviceImprint() {
    return browserTests = ["colorDepth", "plugins", "screenResolution", "userAgent"];
  }
});